import { NgTemplateOutlet } from '@angular/common'
import { Component, input, TemplateRef } from '@angular/core'
import { IconLegacyComponent, IconSize } from '../../deprecated'
import { Icon } from '../icon'
import { Illustration, IllustrationComponent } from '../illustration'

@Component({
  selector: 'ftr-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.css'],
  imports: [IllustrationComponent, IconLegacyComponent, NgTemplateOutlet],
})
/**
 * A component to display when a section is empty
 */
export class EmptyStateComponent {
  message = input<string>()
  illustration = input<Illustration>()
  icon = input<Icon>()
  inline = input<boolean>(false)
  transparent = input<boolean>(false)
  iconSize = input<IconSize>('Large')
  displayTitle = input<string>()
  messageTemplate = input<TemplateRef<unknown> | null>(null)
}
